import { SxProps } from "@mui/material/styles";
import { Theme } from "@mui/material/styles/createTheme";
import Typography from "@mui/material/Typography/Typography";

export default function InlineCode({ children, sx }: { children: React.ReactNode; sx?: SxProps<Theme> }) {
  return (
    <Typography
      component="code"
      sx={{
        backgroundColor: "grey.200",
        padding: "2px 4px",
        borderRadius: "4px",
        fontFamily: "monospace",
        fontSize: "0.875em",
        ...sx,
      }}
    >
      {children}
    </Typography>
  );
}
